// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.video-thumbnail-bar-container {
    position: relative;
    height: fit-content;
    width: 100%;
    overflow: visible;
    pointer-events: none;
}

div.video-thumbnail-bar {
    position: relative;
    display: flex;
    flex-direction: row;
    overflow: visible;
    left: 0px;
    height: 5rem;
    width: var(--thumbnailBarWidth);
    padding: 0px;
    background-color: #32621c;
}

    div.video-thumbnail-bar > canvas {
        margin: 0px 0px;
        overflow: hidden;
    }


div.thumbnail-bitmap-canvas-container {
    width: fit-content;
    height: fit-content;
    overflow: clip;
}

div.video-thumbnail-progress {
    position: absolute;
    display: flex;
    justify-content: start;
    height: 4px;
    width: 100%;
    z-index: 1;
}

    div.video-thumbnail-progress.enabled {
        opacity: 1;
    }

    div.video-thumbnail-progress.disabled {
        opacity: 0;
    }

    div.video-thumbnail-progress > span {
        height: 100%;
        background-color: var(--deep-red)
    }
`, "",{"version":3,"sources":["webpack://./src/Controls/css/VideoThumbnailBar.css"],"names":[],"mappings":"AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,SAAS;IACT,YAAY;IACZ,+BAA+B;IAC/B,YAAY;IACZ,yBAAyB;AAC7B;;IAEI;QACI,eAAe;QACf,gBAAgB;IACpB;;;AAGJ;IACI,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,UAAU;AACd;;IAEI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,YAAY;QACZ;IACJ","sourcesContent":["@import '../../css/App.css';\r\n\r\ndiv.video-thumbnail-bar-container {\r\n    position: relative;\r\n    height: fit-content;\r\n    width: 100%;\r\n    overflow: visible;\r\n    pointer-events: none;\r\n}\r\n\r\ndiv.video-thumbnail-bar {\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: row;\r\n    overflow: visible;\r\n    left: 0px;\r\n    height: 5rem;\r\n    width: var(--thumbnailBarWidth);\r\n    padding: 0px;\r\n    background-color: #32621c;\r\n}\r\n\r\n    div.video-thumbnail-bar > canvas {\r\n        margin: 0px 0px;\r\n        overflow: hidden;\r\n    }\r\n\r\n\r\ndiv.thumbnail-bitmap-canvas-container {\r\n    width: fit-content;\r\n    height: fit-content;\r\n    overflow: clip;\r\n}\r\n\r\ndiv.video-thumbnail-progress {\r\n    position: absolute;\r\n    display: flex;\r\n    justify-content: start;\r\n    height: 4px;\r\n    width: 100%;\r\n    z-index: 1;\r\n}\r\n\r\n    div.video-thumbnail-progress.enabled {\r\n        opacity: 1;\r\n    }\r\n\r\n    div.video-thumbnail-progress.disabled {\r\n        opacity: 0;\r\n    }\r\n\r\n    div.video-thumbnail-progress > span {\r\n        height: 100%;\r\n        background-color: var(--deep-red)\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
